import styled from "styled-components";
import { Flex, Icon } from "@evergis/ui";

const PI_DEG = 180;

export const ProjectAccessDescription = styled.div`
  margin-bottom: 1rem;
  max-width: 40rem;
`;

export const ToggleContainer = styled.div<{ toggled?: boolean }>`
  display: inline-flex;
  width: fit-content;
  cursor: pointer;
  align-items: center;
  user-select: none;

  ${Icon} {
    font-size: 1rem;
    margin-left: 0.25rem;
    transform: ${({ toggled }) => `rotate(${toggled ? PI_DEG : 0}deg)`};
    transition: transform 300ms cubic-bezier(0.15, 1.35, 0.7, 1.5);
  }
`;

export const ProjectDependenciesContainer = styled.div`
  display: flex;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 0 0 2rem;
  width: 100%;
  justify-content: center;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;
`;

export const ProjectItem = styled.div`
  display: flex;
  align-items: baseline;
`;

export const ProjectInformation = styled.div`
  display: flex;
  align-items: baseline;
  max-width: 23rem;
  min-width: 23rem;
`;

export const ProjectIconContainer = styled.div`
  position: relative;
  top: -0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
`;

export const ProjectTitleContainer = styled.div`
  margin-left: 0.12rem;
`;

export const ProjectTitle = styled.div`
  position: relative;
  top: -0.08rem;
  color: ${({ theme }) => theme.palette.textPrimary};
  max-width: 18.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProjectSubtitle = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme }) => theme.palette.textDisabled};
  height: 0.875rem;
  max-width: 18.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProjectControl = styled.div`
  position: relative;
  top: 0.1rem;
  box-sizing: border-box;
`;

export const TableStructure = styled.ul`
  position: relative;
  list-style: none;
  margin: 1.65rem 0 0;
  padding: 0 0 0 1.5rem;

  &::before {
    content: "";
    border-left: 1px solid rgba(151, 151, 151, 0.28);
    position: absolute;
    top: 2rem;
    left: 2.5rem;
    height: calc(100% - 3.16rem);
  }
`;

export const TableItem = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TableIconContainer = styled.div`
  position: relative;
  top: -0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
`;

export const TableTitleContainer = styled.div`
  margin-left: 0.12rem;
`;

export const TableTitle = styled.div`
  position: relative;
  top: -0.08rem;
  color: ${({ theme }) => theme.palette.textPrimary};
  max-width: 17rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableSubtitle = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme }) => theme.palette.textDisabled};
  height: 0.875rem;
  max-width: 17rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableInformation = styled.div<{ warning?: boolean }>`
  display: flex;
  align-items: baseline;
  max-width: 21.5rem;
  min-width: 21.5rem;

  ${TableIconContainer} {
    ${Icon} {
      &:after {
        color: ${({ warning }) => warning && "#FF6933"};
      }
    }
  }

  ${TableTitle} {
    color: ${({ warning }) => warning && "#FF6933"};
  }
`;

export const TableControl = styled.div`
  position: relative;
  top: 0.1rem;
  box-sizing: border-box;
`;

export const LayerTitle = styled.div`
  display: flex;
  align-items: center;
  padding-right: 1rem;
  height: 2rem;
  box-sizing: border-box;
`;

export const LayerTitleText = styled.div`
  position: relative;
  max-width: 14.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LayerInformation = styled.div<{ warning?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  max-width: 16.94rem;
  min-width: 16.94rem;

  ${LayerTitle} {
    color: ${({ warning }) => warning && "#FF6933"};
  }
`;

export const LayerItem = styled.li`
  display: flex;
  align-items: baseline;
  height: 2.3rem;

  &::before {
    content: "";
    position: relative;
    box-sizing: border-box;
    top: -0.16rem;
    min-width: 3.06rem;
    max-width: 3.06rem;
    border-bottom: 1px solid rgba(151, 151, 151, 0.28);
    margin: 0 0.5rem 0 1rem;
  }

  ${LayerTitle} {
    margin-left: 0;
  }

  ${LayerTitleText} {
    top: 0;
  }
`;

export const LayerControl = styled.div`
  position: relative;
  top: 0.1rem;
  min-width: 20rem;
  max-width: 20rem;
`;

export const ProjectControlsPanel = styled(Flex)`
  width: 100%;
  margin-top: 1rem;
  align-items: center;
  justify-content: space-between;
`;
